import { useParams } from 'react-router-dom'

import { PaginationProvider } from '../../providers/PaginationProvider/PaginationProvider'
import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'

import { AssignFlexPackages } from '../../components/UnifiedSearchList/AssignFlexPackages'

export default function AssignFlexPackagesPage() {
  const { uuid } = useParams()

  return (
    <PaginationProvider>
      <ModalProvider>
        <AssignFlexPackages uuid={uuid} />
      </ModalProvider>
    </PaginationProvider>
  )
}
